import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import { Radio } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { GoCellLink, Link } from "@codeArt/components/button/link";
import _ from "lodash";
import { empty } from "@codeArt/utils/common";
import { getColumnField } from "./util";

/* const useStyles = makeStyles(theme => ({
  cell: {
    height: "100%",
    textAlign: "center",
    border: "none"
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
})); */

const Rows = ({
  columns,
  onRowSelect,
  handleRowClick,
  handleKeyDown,
  handleTargetClick,
  separator,
  rows,
  hover,
  go,
  radioName,
  checkbox,
  radio,
  getRowKey,
  getRowDisabled,
  isSelected,
  fixed
}) => {

  const useStyles = makeStyles(theme => ({
    selected: {
      backgroundColor: "#e4e7f6 !important"
    }
  }));

  const noLine = !empty(separator) && (separator === false || separator.pc === false);
  const classes = useStyles();
  return rows.map((row, rowIndex) => {
    const key = getRowKey(row);
    const selected = isSelected(key);
    return (
      <TableRow
        classes={classes}
        hover={hover}
        className={`${onRowSelect ? "c-pointer" : ""}`}
        onClick={event => handleRowClick(event, key, row)} //取消整行选择
        onKeyDown={event => handleKeyDown(event, key)}
        role="checkbox"
        aria-checked={selected}
        tabIndex={-1}
        key={`row_${rowIndex}`}
        selected={selected}
      >
        <SelectTD
          /*  value={key.value} */
          _key={key}
          selected={selected}
          radioName={radioName}
          checkbox={checkbox}
          radio={radio}
          handleTargetClick={handleTargetClick}
          noLine={noLine}
          row={row}
          disabled={Boolean(getRowDisabled(row))}
        />
        {columns.map((column, i) => {
          let field = getColumnField(column);
          let { onClick, className, light, style, width } = column;

          if (!className) {
            className = light ? "c-text-grey c-text-s1" : "c-text-s1";
          }

          let tdStyle = {};
          if (width) {
            tdStyle.width = width;
          }
          tdStyle = { ...tdStyle, ...style };

          if (!onClick) {
            if (go) onClick = go;
          }

          return (
            <TableCell
              key={i}
              onClick={
                onClick ? (
                  () => {
                    onClick(row);
                  }
                ) : null
              }
              align={column.align}
              style={tdStyle}
              className={`${noLine ? "c-lb0" : ""} ${onClick || go
                ? "c-pointer"
                : ""} ${className}`}
              padding={column.disablePadding ? "none" : "normal"}
            >
              <Content
                row={row}
                rows={rows}
                column={column}
                rowIndex={rowIndex}
                field={field}
              />
            </TableCell>
          );
        })}
        {go ? <GoTD go={go} noLine={noLine} row={row}/> : null}
        {fixed ? <PlaceholderTD /> : null}
      </TableRow>
    );
  });
};

export { Rows };

const GoTD = ({ row, go, noLine }) => {
  return (
    <TableCell
      key={"column-go"}
      onClick={() => {
        go(row);
      }}
      align={"center"}
      width="50px"
      className={`${noLine ? "c-lb0" : ""} c-pointer`}
      padding={"normal"}
    >
      <GoCellLink color="primary" />
    </TableCell>
  );
};

const PlaceholderTD = ({ noLine }) => {
  return (
    <TableCell
      key={"column-placeholder"}
      width="auto"
      className={`${noLine ? "c-lb0" : ""} c-pointer`}
      padding={"none"}
    />
  );
};

const SelectTD = ({
  /* value, */
  _key,
  handleTargetClick,
  noLine,
  checkbox,
  radio,
  disabled,
  radioName,
  selected,
  row
}) => {
  if (checkbox)
    return (
      <TableCell padding="checkbox" className={`${noLine ? "c-lb0" : ""}`}>
        <Checkbox
          disabled={disabled}
          color="primary"
          checked={selected}
          row={row}
          onClick={e => handleTargetClick(e, _key, row)}
        />
      </TableCell>
    );

  if (radio)
    return (
      <TableCell padding="checkbox" className={`${noLine ? "c-lb0" : ""}`}>
        <Radio
          name={radioName}
          color="primary"
          checked={selected}
          onClick={e => handleTargetClick(e, _key, row)} //由value改成key
        />
      </TableCell>
    );

  return null;
};

const Content = ({ row, column, rowIndex, field,rows }) => {
  let { component, text, ellipsis, go, href } = column;
  if (component) return component(row, rowIndex,{rows});
  let content = text ? text(row, rowIndex) : row[field];
  if (go)
    return (
      <Link
        size="xs"
        inline={true}
        onClick={e => {
          go(row, rowIndex);
          e.stopPropagation();
        }}
      >
        {content}
      </Link>
    );
  if (href)
    return (
      <Link size="xs" inline={true} href={href(row, rowIndex)}>
        {content}
      </Link>
    );
  return ellipsis === false ? (
    content
  ) : (
    <p className={`mb-0 c-ellipsis-1`}>{content}</p>
  );
};
